import {
  LOCAL_STORAGE_ACCESS_TOKEN,
  LOCAL_STORAGE_REFRESH_TOKEN,
  LOCAL_STORAGE_USER_TYPE,
  LOCAL_STORAGE_KYC_VALUE,
  LOCAL_STORAGE_USER_DATA,
  ATK_COOKIE,
  USER_ROLE_COOKIE,
  ACCOUNT_TYPE_COOKIE,
  KYC_STATUS_COOKIE,
  IS_STRIPE_COOKIE,
} from "../services/constants";
import { cookieFn } from "./cookieFn";
import { LocalStorageFn } from "./util";

export const saveAuthUserDetails = (resp: any) => {
  const saveUserType = resp.type.label !== "User" ? "Agent" : resp.type.label;
  LocalStorageFn.setItem(LOCAL_STORAGE_ACCESS_TOKEN, resp.token);
  LocalStorageFn.setItem(LOCAL_STORAGE_REFRESH_TOKEN, resp.refreshToken);
  LocalStorageFn.setItem(LOCAL_STORAGE_USER_TYPE, saveUserType);
  LocalStorageFn.setItem(LOCAL_STORAGE_KYC_VALUE, resp.kyc.value);
  LocalStorageFn.setObjectItem(LOCAL_STORAGE_USER_DATA, resp);
  setAuthCookies(resp);
};

export const setAuthCookies = (resp: any) => {
  cookieFn.setCookie(ATK_COOKIE, resp.token, "/");
  cookieFn.setCookie(USER_ROLE_COOKIE, resp.role, "/");
  cookieFn.setCookie(ACCOUNT_TYPE_COOKIE, resp.type.value, "/");
  cookieFn.setCookie(KYC_STATUS_COOKIE, resp.kyc.value, "/");
  cookieFn.setCookie(IS_STRIPE_COOKIE, resp.hasStripe, "/");
};
export const clearUserAuthStorageFn = () => {
  // Clear cookies
  cookieFn.deleteCookie(ATK_COOKIE, "");
  cookieFn.deleteCookie(USER_ROLE_COOKIE, "");
  cookieFn.deleteCookie(ACCOUNT_TYPE_COOKIE, "");
  cookieFn.deleteCookie(KYC_STATUS_COOKIE, "");
  cookieFn.deleteCookie(IS_STRIPE_COOKIE, "");
  // Clear local storage
  LocalStorageFn.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
  LocalStorageFn.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
  LocalStorageFn.removeItem(LOCAL_STORAGE_USER_TYPE);
  LocalStorageFn.removeItem(LOCAL_STORAGE_KYC_VALUE);
  // Clear user data
  LocalStorageFn.removeItem(LOCAL_STORAGE_USER_DATA);
};
